import React, { useState, useMemo } from "react";
import { Input } from "antd";

const MaskInput = ({
  placeholder,
  mask = "xxxxx-xxxxxxx-x",
  maxLength = 15,
  disabled = false,
  onChange,
  allowInput = (value) => value.replace(/\D/g, ""),
  ...rest
}) => {
  const [inputValue, setInputValue] = useState("");
  const [firstDash, secondDash] = useMemo(() => {
    if (!mask) return [-1, -1]
    const first = mask.indexOf("-")
    const second = mask.indexOf("-", first + 1)
    return [first, second]
  }, [mask])

  const handleInputChange = (e) => {
    let rawValue = allowInput(e.target.value);
    formatInput(rawValue, inputValue);
  };

  const formatInput = (newValue, prevValue) => {
    let formattedValue = newValue.replace(/-/g, "");
    if (prevValue.length > newValue.length) {
      if (prevValue[prevValue.length - 1] === "-") {
        formattedValue = formattedValue.slice(0, -1);
      }
    }
    if (firstDash !== -1 && formattedValue.length > firstDash) {
      formattedValue = `${formattedValue.slice(0, firstDash)}-${formattedValue.slice(firstDash)}`;
    }
    if (secondDash !== -1 && formattedValue.length > secondDash) {
      formattedValue = `${formattedValue.slice(0, secondDash)}-${formattedValue.slice(secondDash)}`;
    }

    if (formattedValue.length > maxLength) {
      formattedValue = formattedValue.slice(0, maxLength);
    }

    setInputValue(formattedValue);
    onChange?.(formattedValue);
  };

  return (
    <Input
      value={inputValue}
      onChange={handleInputChange}
      placeholder={placeholder}
      maxLength={maxLength}
      disabled={disabled}
      {...rest}
    />
  );
};

export default MaskInput;
